// src/components/TrendsSection.js
import React, { useEffect, useState } from "react";
import "./TrendsSection.css";

/* ----------- Ortak ayarlar ----------- */
const baseUrl = "https://apiportal.mbsays.com/public/api";
const token = sessionStorage.getItem("authToken");
const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
const currentUserId = storedUser?.id;
const isAdmin =
  storedUser?.role === "admin" || storedUser?.is_admin === 1;

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  ...(token && { Authorization: `Bearer ${token}` }),
};

const TrendsSection = () => {
  /* ----------- State ----------- */
  const [trends, setTrends] = useState([]);
  const [loading, setLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentTrend, setCurrentTrend] = useState(null);

  /* ----------- Trendleri Çek ----------- */
  useEffect(() => {
    fetchTrends();
  }, []);

  const fetchTrends = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${baseUrl}/trends?per_page=100`, { headers });
      const json = await res.json();
      setTrends(json.data || json);          // (Laravel pagination varsa .data)
    } catch (e) {
      console.error("Trendler alınamadı:", e);
    } finally {
      setLoading(false);
    }
  };

  /* ----------- Form Aç/Kapa ----------- */
  const openAddForm = () => {
    setCurrentTrend({ title: "", description: "", link: "" });
    setIsEditing(false);
    setModalOpen(true);
  };

  const openEditForm = (tr) => {
    setCurrentTrend({ ...tr });
    setIsEditing(true);
    setModalOpen(true);
  };

  const closeForm = () => {
    setModalOpen(false);
    setCurrentTrend(null);
  };

  /* ----------- Input Değişimleri ----------- */
  const handleChange = ({ target: { name, value } }) =>
    setCurrentTrend((p) => ({ ...p, [name]: value }));

  /* ----------- Kaydet / Güncelle ----------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, description, link } = currentTrend;
    if (!title.trim() || !description.trim()) {
      alert("Başlık ve açıklama zorunlu");
      return;
    }

    const method = isEditing ? "PUT" : "POST";
    const url = isEditing
      ? `${baseUrl}/trends/${currentTrend.id}`
      : `${baseUrl}/trends`;

    try {
      const res = await fetch(url, {
        method,
        headers,
        body: JSON.stringify({ title, description, link }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || res.statusText);
      }
      await fetchTrends();
      closeForm();
    } catch (e) {
      console.error("Trend kaydedilemedi:", e);
      alert(e.message || "Bilinmeyen hata");
    }
  };

  /* ----------- Sil ----------- */
  const deleteTrend = async (id) => {
    if (!window.confirm("Bu trendi silmek istediğinize emin misiniz?")) return;
    try {
      const res = await fetch(`${baseUrl}/trends/${id}`, {
        method: "DELETE",
        headers,
      });
      if (!res.ok) throw new Error("Silinemedi");
      await fetchTrends();
    } catch (e) {
      console.error("Silme hatası:", e);
      alert(e.message || "Bilinmeyen hata");
    }
  };

  /* ----------- Yardımcı ----------- */
  const fmt = (d) => (d ? new Date(d).toLocaleString("tr-TR") : "-");
  const shorten = (str, len = 60) =>
    str && str.length > len ? `${str.slice(0, len - 3)}…` : str;

  /* ----------- Render ----------- */
  return (
    <div className="trends-section">
      <h2>Trend Yönetimi</h2>

      {!modalOpen && (
        <button className="add-button" onClick={openAddForm}>
          Yeni Trend Ekle
        </button>
      )}

      {loading ? (
        <p className="loading-text">Yükleniyor…</p>
      ) : (
        <div className="trend-list">
          {trends.length ? (
            <table className="trend-table">
              <thead>
                <tr>
                  <th>Başlık</th>
                  <th>Açıklama</th>
                  <th>Link</th>
                  <th>Oluşturan</th>
                  <th>Tarih</th>
                  <th>Aksiyon</th>
                </tr>
              </thead>
              <tbody>
                {trends.map((tr) => {
                  const canEdit = tr.user_id === currentUserId || isAdmin;
                  const canDelete = isAdmin;
                  return (
                    <tr key={tr.id}>
                      <td>{tr.title}</td>
                      <td title={tr.description}>{shorten(tr.description)}</td>
                      <td>
                        {tr.link ? (
                          <a
                            href={tr.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {shorten(tr.link, 30)}
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{tr.user?.name}</td>
                      <td>{fmt(tr.created_at)}</td>
                      <td className="actions">
                        {canEdit && (
                          <button
                            className="edit-btn"
                            onClick={() => openEditForm(tr)}
                          >
                            Düzenle
                          </button>
                        )}
                        {canDelete && (
                          <button
                            className="delete-btn"
                            onClick={() => deleteTrend(tr.id)}
                          >
                            Sil
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>Henüz trend yok.</p>
          )}
        </div>
      )}

      {/* ----------- Modal ----------- */}
      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{isEditing ? "Trendi Düzenle" : "Yeni Trend Ekle"}</h3>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Başlık</label>
                <input
                  type="text"
                  name="title"
                  value={currentTrend.title}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Açıklama</label>
                <input
                  type="text"
                  name="description"
                  value={currentTrend.description}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Link (opsiyonel)</label>
                <input
                  type="url"
                  name="link"
                  value={currentTrend.link || ""}
                  onChange={handleChange}
                  placeholder="https://..."
                />
              </div>

              <div className="form-buttons">
                <button type="submit" className="submit-button">
                  {isEditing ? "Güncelle" : "Kaydet"}
                </button>
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeForm}
                >
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrendsSection;
